import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const CustomTooltipContainer = styled.div<{ borderColor?: string }>`
  ${({ theme, borderColor }) => css`
    background: ${theme.colors.lightest};
    border: 1px solid ${borderColor ?? '#3a9397'};
    border-radius: 8px;
    padding: 12px;
    box-shadow: 4px 4px 8px 0 rgba(0, 0, 0, 0.16);
  `}
`

export const TooltipLabel = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    line-height: 12px;
    font-weight: 600;
    color: #767676;
  `}
`

export const TooltipLabelIcon = styled.span<{ color: string }>`
  ${({ color }) => css`
    display: flex;
    align-items: center;
    color: ${color};
  `}
`

export const TooltipItem = styled.div`
  ${() => css`
    display: flex;
    gap: 8px;
    margin-top: 16px;

    &:first-of-type {
      margin-top: 0;
    }
  `}
`

export const TooltipLabelItem = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 8px;
  `}
`

export const TooltipColorCircle = styled.div<{ color: string }>`
  ${({ color }) => css`
    width: 16px;
    height: 16px;
    background-color: ${color};
    border-radius: 50%;
    flex-shrink: 0;
  `}
`

export const TooltipValues = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `}
`

export const TooltiplabelItem = styled.span`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    line-height: 12px;
    font-weight: 600;
    color: #767676;
    margin-top: 2px;
  `}
`

export const TooltipValue = styled.span`
  ${() => css`
    font-size: 12px;
    line-height: 12px;
    font-weight: 400;
    color: #767676;
    margin-top: 2px;
  `}
`
